"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var List = function (props) {
    var imageUrl = props.imageUrl, href = props.href, extendProps = props.extendProps;
    var hasHref = !!href.replace(/\s/g, '');
    var realHref = hasHref ? href : 'javascript:void(null);';
    return (react_1.default.createElement("a", __assign({ className: (0, classnames_1.default)('list', {
            'no-href': !hasHref,
        }), href: realHref }, (extendProps || {})),
        react_1.default.createElement("img", { src: imageUrl, alt: "" })));
};
exports.default = List;
//# sourceMappingURL=List.js.map